export enum Status {
    uninitialized,
    loading,
    loaded,
    error
}
